import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import i18n from "@/i18n";
import { handleAccessError } from "./account";
import { errorMessage } from "./errors";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: { silent?: boolean };
  }
}

/**
 * The app's query client. Stock figures depend on almost everything, so any change refreshes
 * every visible query. With accounts, an expired session goes to the sign-in page.
 */
export function createQueryClient(): QueryClient {
  const client: QueryClient = new QueryClient({
    defaultOptions: {
      queries: { staleTime: 10_000, retry: 1 },
      mutations: { retry: false },
    },
    queryCache: new QueryCache({ onError: (error) => handleAccessError(error) }),
    mutationCache: new MutationCache({
      onSuccess: () => client.invalidateQueries(),
      onError: (error, _variables, _context, mutation) => {
        if (handleAccessError(error) || mutation.meta?.silent) return;
        toast.error(errorMessage(error, i18n.t));
      },
    }),
  });
  return client;
}
